import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote, Star } from "lucide-react";
import { useApi } from "@/lib/api";

export const TestimonialSlider = () => {
  const { data } = useApi("/testimonials");
  const items = data || [];
  const [i, setI] = useState(0);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setI((p) => (p + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (!items.length) return null;
  const t = items[i % items.length];
  const go = (d) => setI((p) => (p + d + items.length) % items.length);

  return (
    <div className="card-base relative mx-auto max-w-4xl p-8 sm:p-12" data-testid="testimonial-slider">
      <Quote className="absolute right-8 top-8 h-14 w-14 text-sky/20" aria-hidden="true" />
      <AnimatePresence mode="wait">
        <motion.figure key={t.id} initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -30 }} transition={{ duration: 0.35 }}>
          <div className="flex gap-1" aria-label={`${t.rating} star rating`}>
            {Array.from({ length: t.rating || 5 }).map((_, k) => <Star key={k} className="h-5 w-5 fill-cta text-cta" />)}
          </div>
          <blockquote className="mt-6 font-heading text-xl font-medium leading-relaxed text-navy sm:text-2xl" data-testid="testimonial-quote">“{t.quote}”</blockquote>
          <figcaption className="mt-8 flex items-center gap-4">
            <span className="grid h-12 w-12 place-items-center rounded-full bg-indigo-brand font-heading font-bold text-white">{t.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}</span>
            <div>
              <p className="font-heading font-bold text-navy">{t.name}</p>
              <p className="text-sm text-muted2">{t.role}, {t.company}</p>
            </div>
          </figcaption>
        </motion.figure>
      </AnimatePresence>
      <div className="mt-8 flex items-center justify-between">
        <div className="flex gap-1.5">
          {items.map((x, k) => (
            <button key={x.id} onClick={() => setI(k)} aria-label={`Show testimonial ${k + 1}`} className={`h-2 rounded-full transition-[width,background-color] ${k === i ? "w-8 bg-ocean" : "w-2 bg-line"}`} data-testid={`testimonial-dot-${k}`} />
          ))}
        </div>
        <div className="flex gap-2">
          <button onClick={() => go(-1)} aria-label="Previous testimonial" className="grid h-11 w-11 place-items-center rounded-full border border-line text-navy transition-colors hover:border-ocean hover:text-ocean" data-testid="testimonial-prev-btn"><ChevronLeft className="h-5 w-5" /></button>
          <button onClick={() => go(1)} aria-label="Next testimonial" className="grid h-11 w-11 place-items-center rounded-full border border-line text-navy transition-colors hover:border-ocean hover:text-ocean" data-testid="testimonial-next-btn"><ChevronRight className="h-5 w-5" /></button>
        </div>
      </div>
    </div>
  );
};
